/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { brand } from "./config/brand";

// index.html is served statically (Bun.serve, no interpolation), so apply the
// brand name/description to the document at boot — the single runtime seam.
document.title = brand.name;
document
  .querySelector('meta[name="description"]')
  ?.setAttribute("content", brand.description);

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
